import { render, staticRenderFns } from "./RobberyTypeQuestion.vue?vue&type=template&id=43baa1fe&scoped=true"
import script from "./RobberyTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyTypeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43baa1fe",
  null
  
)

export default component.exports